// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO (notifications rework 2026-10, design/notifications-rework A): the phone Notifications
// page is one short list; Agents, pop-ups, sounds, read aloud, the desk delay, reply mentions and
// this device each open as a page of their own inside the tab. MobileSettingsView reads this for
// the header title and sends Back here first.

import type {MessageDescriptor} from '@lingui/core';
import {msg} from '@lingui/core/macro';
import {makeAutoObservable} from 'mobx';

export type PhoneNotificationsSubpage = 'agents' | 'popups' | 'sounds' | 'read-aloud' | 'desk' | 'mention' | 'device';

/** The header title of each page. */
export const PHONE_NOTIFICATIONS_SUBPAGE_TITLES: Record<PhoneNotificationsSubpage, MessageDescriptor> = {
	agents: msg({message: 'Agents', comment: 'Phone Settings > Notifications > Agents: header title of the page.'}),
	popups: msg({message: 'Pop-ups', comment: 'Phone Settings > Notifications > Pop-ups: header title of the page.'}),
	sounds: msg({message: 'Sounds', comment: 'Phone Settings > Notifications > Sounds: header title of the page.'}),
	'read-aloud': msg({
		message: 'Read aloud',
		comment: 'Phone Settings > Notifications > Read aloud (text-to-speech): header title of the page.',
	}),
	desk: msg({
		message: "While I'm at my desk",
		comment:
			'Phone Settings > Notifications: header title of the page that sets when the phone gets pushes while the desktop app is in use.',
	}),
	mention: msg({
		message: 'Mention when I reply',
		comment: 'Phone Settings > Notifications: header title of the page for the reply @mention preference.',
	}),
	device: msg({
		message: 'This device',
		comment: "Phone Settings > Notifications: header title of the page with this phone's push subscription.",
	}),
};

class PhoneNotificationsPageStore {
	page: PhoneNotificationsSubpage | null = null;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	get isSubpage(): boolean {
		return this.page !== null;
	}

	open(page: PhoneNotificationsSubpage): void {
		this.page = page;
	}

	back(): void {
		this.page = null;
	}
}

export default new PhoneNotificationsPageStore();
